import { Layout } from "@/components/Layout";
import { NoindexSeo } from "@/components/Seo";
import { Link } from "react-router-dom";
import "./legal.css";

export default function MentionsLegalesPage() {
  return (
    <Layout>
      <NoindexSeo
        title="Mentions légales"
        path="/mentions-legales"
      />
      <div className="legal">
        <div className="legal-wrap">
          <h1 className="legal-h1">Mentions légales</h1>
          <p className="legal-updated">Mise à jour : 12 juillet 2026</p>

          <p className="legal-intro">
            Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin
            2004 pour la confiance dans l'économie numérique (LCEN), les présentes
            mentions légales décrivent l'éditeur et l'hébergeur du site{" "}
            <b>Mon Diag Énergétique</b>.
          </p>

          <h2 className="legal-h2">1. Éditeur du site</h2>
          <table className="legal-table">
            <tbody>
              <tr>
                <td><b>Nom</b></td>
                <td>Pierre Thurau</td>
              </tr>
            </tbody>
          </table>

          <h2 className="legal-h2">2. Hébergeur</h2>
          <p className="legal-p">
            Le site est hébergé par <b>Scaleway</b>, une marque de la société
            Iliad, dont le siège social est situé :
          </p>
          <table className="legal-table">
            <tbody>
              <tr>
                <td><b>Société</b></td>
                <td>Scaleway SAS</td>
              </tr>
              <tr>
                <td><b>Adresse</b></td>
                <td>8 rue de la Ville l'Évêque, 75008 Paris, France</td>
              </tr>
              <tr>
                <td><b>Téléphone</b></td>
                <td>+33 1 84 88 26 90</td>
              </tr>
              <tr>
                <td><b>Site web</b></td>
                <td>https://www.scaleway.com</td>
              </tr>
            </tbody>
          </table>
          <p className="legal-p">
            Les données sont hébergées en France, sur des serveurs situés dans
            l'Union européenne, conformément au RGPD.
          </p>

          <h2 className="legal-h2">3. Propriété intellectuelle</h2>
          <p className="legal-p">
            L'ensemble des éléments du site (design, textes, illustrations, code
            source du moteur de calcul, logo) est la propriété exclusive de
            l'Éditeur, sauf mention contraire. Toute reproduction, représentation
            ou diffusion, totale ou partielle, sans autorisation écrite préalable
            de l'Éditeur, est interdite et constitue une contrefaçon sanctionnée
            par les articles L.335-2 et suivants du Code de la propriété
            intellectuelle.
          </p>
          <p className="legal-p">
            La méthode 3CL-DPE 2021 est un texte réglementaire public (arrêté du
            31 mars 2021). Les données de l'ADEME utilisées sont publiques et
            librement accessibles sur data.ademe.fr.
          </p>

          <h2 className="legal-h2">4. Nature du service et responsabilité</h2>
          <div className="legal-callout">
            <b>Estimation pédagogique, sans valeur légale.</b> Mon Diag
            Énergétique n'est pas un DPE réglementaire. Il ne comporte pas de
            numéro ADEME et ne peut être utilisé pour la vente, la location ou
            les démarches administratives. Pour un DPE officiel, faites appel à
            un diagnostiqueur certifié.
          </div>
          <p className="legal-p">
            L'Éditeur s'efforce de fournir des informations exactes et à jour.
            Toutefois, l'Éditeur ne saurait être tenu responsable des erreurs,
            omissions ou résultats imprécis qui pourraient apparaître sur le
            site, ni des conséquences qui en résulteraient. Les estimations
            fournies dépendent de la exactitude des données saisies par
            l'utilisateur.
          </p>

          <h2 className="legal-h2">5. Liens hypertextes</h2>
          <p className="legal-p">
            Le site peut contenir des liens vers des sites externes (ADEME,
            annuaire des diagnostiqueurs, partenaires commerciaux). L'Éditeur
            n'exerce aucun contrôle sur ces sites et décline toute responsabilité
            quant à leur contenu.
          </p>
          <p className="legal-p">
            Les liens partenaires sont identifiés par la mention « partenaire ».
            Les liens vers les sites officiels sont identifiés par la mention
            « officiel » et ne génèrent aucune rémunération.
          </p>

          <h2 className="legal-h2">6. Données personnelles</h2>
          <p className="legal-p">
            Le traitement des données personnelles est décrit dans la{" "}
            <Link to="/confidentialite" className="legal-link">
              politique de confidentialité
            </Link>
            . Le détail de l'utilisation des cookies est disponible dans la{" "}
            <Link to="/cookies" className="legal-link">
              politique de gestion des cookies
            </Link>.
          </p>

          <h2 className="legal-h2">7. Contact</h2>
          <p className="legal-p">
            Pour toute question relative aux présentes mentions légales :
            <br />
            E-mail : <a href="mailto:contact@diag-energetique.fr" className="legal-link">contact@diag-energetique.fr</a>
          </p>
        </div>
      </div>
    </Layout>
  );
}
